export var E_ComponentVariant;
(function (E_ComponentVariant) {
    E_ComponentVariant["Primary"] = "primary";
    E_ComponentVariant["Secondary"] = "secondary";
    E_ComponentVariant["Success"] = "success";
    E_ComponentVariant["Danger"] = "danger";
    E_ComponentVariant["Warning"] = "warning";
    E_ComponentVariant["Info"] = "info";
    E_ComponentVariant["Dark"] = "dark";
})(E_ComponentVariant || (E_ComponentVariant = {}));
